import { render, staticRenderFns } from "./schemes.vue?vue&type=template&id=62625c46&scoped=true"
import script from "./schemes.vue?vue&type=script&lang=js"
export * from "./schemes.vue?vue&type=script&lang=js"
import style0 from "./schemes.vue?vue&type=style&index=0&id=62625c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62625c46",
  null
  
)

export default component.exports